import { render, staticRenderFns } from "./ApprovalWork.vue?vue&type=template&id=013aeeea"
import script from "./ApprovalWork.vue?vue&type=script&lang=js"
export * from "./ApprovalWork.vue?vue&type=script&lang=js"
import style0 from "./ApprovalWork.vue?vue&type=style&index=0&id=013aeeea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports